import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-71" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-72" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-73" data-mp="129h0hmovcycw">
          Rédigez des documents juridiques <span className="text-grape" data-id="element-74" data-mp="s9gj46ak8sbc">irréprochables</span> en quelques <span className="text-blush" data-id="element-75" data-mp="nb6kflpmn9kz">secondes</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-76" data-mp="3d1ihv20l0yjq">
          La solution ultime pour réduire votre temps de rédaction de 80% grâce aux Frameworks d'IA validés par des avocats
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-77" data-mp="3o6kfhi5voc54">
          <img src="https://cdn.magicpatterns.com/uploads/1jVCLviKSBTeCcN8yV2BR8/ChatGPT_Image_30_sept_2026,_15_44_34.webp" alt="Les 100 Précédents Juridiques AI™ — Système en 6 volumes + 4 bonus professionnels" width={1536} height={1024} sizes="(min-width: 640px) 560px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-[3/2] h-auto w-full max-w-[560px] object-contain" data-id="element-78" data-mp="30hhsdush5r38" />
        </motion.div>

        <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-79" data-mp="2hjoy1gvx2phg">
          6 Volumes + 4 Bonus Professionnels · ⭐ 4.9 (Plus de 500 avocats satisfaits) · ⚡ Accès Instantané
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-80" data-mp="s3cm2bn71lr3">
          <CTAButton href="#pricing" data-id="element-81" data-mp="nb1imyt8vhts">Voir les 100 Précédents maintenant</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-82" data-mp="iboywmxo6qvf">
            <span className="font-bold text-plum" data-id="element-83" data-mp="dd59gcjvawyb">LE SYSTÈME DE COMMANDE IA N°1 POUR 2026.</span> Conçu pour les avocats solos, les associés et les professionnels du droit qui exigent une documentation précise, juridiquement solide et rapide.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-84" data-mp="162c8rdr5bqkm">
            Contentieux · Contrats · Instruction · Intake · Recherche · Gestion de Cabinet
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-85" data-mp="x0uwy7krub1q">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-86" data-mp="3hqu2kaecg816">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-87" data-mp="1x7hxtje7id3i" />
                {label}
              </span>)}
          </div>

          
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-88" data-mp="268y53i9q5z3i">
          🔥 Offre à durée limitée · Le prix reviendra à 54 € bientôt
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-89" data-mp="2kyn9dmd46j80">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="2p0qpioaqabzm" />
          25 avocats consultent ce kit juridique en ce moment
        </p>
      </div>
    </header>;
}